import type { RouteObject } from 'react-router-dom';

/**
 * Public legal pages, outside the signed-in shell (Google Play requires both):
 *   /privacy          the privacy policy (PrivacyPage)
 *   /delete-account   how to have an account and its data deleted (DeleteAccountPage)
 */
export const legalRoutes: RouteObject[] = [
  { path: 'privacy', lazy: async () => ({ Component: (await import('./PrivacyPage')).PrivacyPage }) },
  { path: 'delete-account', lazy: async () => ({ Component: (await import('./DeleteAccountPage')).DeleteAccountPage }) },
];
